import { useEffect, useState } from 'react'

import { Container } from 'components/container'
import { NUMBER_OF_ITEMS, SELECTED_IMAGES } from './images'
import { CarouselSection, Item, Container as StyledContainer } from './styled'

export const Carousel = () => {
  const [offset, setOffset] = useState(1)

  useEffect(() => {
    let interval = setInterval(() => setOffset(v => v + 1), 3000)

    const onVisibilityChange = () => {
      clearInterval(interval)

      if (document.visibilityState === 'visible') {
        interval = setInterval(() => setOffset(v => v + 1), 3000)
      }
    }

    document.addEventListener('visibilitychange', onVisibilityChange, false)

    return () => {
      clearInterval(interval)
      document.removeEventListener('visibilitychange', onVisibilityChange)
    }
  }, [setOffset])

  return (
    <CarouselSection>
      <Container>
        <StyledContainer>
          <ul key={offset}>
            {[...Array(NUMBER_OF_ITEMS)].map((_, i) => (
              <Item index={i + 1} key={i}>
                <img
                  src={
                    SELECTED_IMAGES[
                      (NUMBER_OF_ITEMS - i + offset) % SELECTED_IMAGES.length
                    ]
                  }
                  alt=""
                />
              </Item>
            ))}
          </ul>
        </StyledContainer>
      </Container>
    </CarouselSection>
  )
}
